import { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import { setSelectedToolbarTabIndex } from '../../store/ui/uiSlice'
import ScrollWrapperWithControls from '../ScrollWrapperWithControls/ScrollWrapperWithControls'
import EditItemPanel from '../EditItemPanel/EditItemPanel'
import * as Styled from './styles'
import Selections from '../Selections/Selections'
import { useAppDispatch, useAppSelector } from '../../hooks'

const UserConfiguration = () => {
  const dispatch = useAppDispatch()

  const { meta, props, items } = useAppSelector((state) => state.configResult)
  const { assetBaseUrl, content } = useAppSelector((state) => state.init)
  useAppSelector((state) => state.selectedItem)
  const { selectedToolbarTabIndex } = useAppSelector((state) => state.ui)

  useEffect(() => {
    dispatch(setSelectedToolbarTabIndex(0))
  }, [dispatch])

  return (
    <Styled.Toolbar data-testid="user-configuration-toolbar">
      {meta && props && items ? (
        <>
          <Tabs
            selectedIndex={selectedToolbarTabIndex}
            onSelect={(index) => {
              dispatch(setSelectedToolbarTabIndex(index))
            }}
          >
            <ScrollWrapperWithControls hideButtons={true} selectedIndex={selectedToolbarTabIndex}>
              <TabList>
                {content?.tabs?.map((tab: any, index: number) => (
                  <Tab key={tab.title + index} data-testid={`tab-${tab.title.toLowerCase()}`}>
                    <img title={tab.title} alt={tab.title} src={`${assetBaseUrl}${tab.image}`} />
                    {tab.title}
                  </Tab>
                ))}
              </TabList>
            </ScrollWrapperWithControls>

            <TabPanel>
              <Selections tab={'size'} />
            </TabPanel>
            <TabPanel data-testid="roof-kind-tab-panel">
              <Selections tab={'roof'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'loft'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'doors'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'windows'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'gates'} />
            </TabPanel>
            <TabPanel>
              <Selections tab={'options'} />
            </TabPanel>
          </Tabs>
          <EditItemPanel />
        </>
      ) : (
        <>
          <Skeleton width="90%" height="200px" />
        </>
      )}
    </Styled.Toolbar>
  )
}

export default UserConfiguration
